import { useCallback } from "react";

import { Run } from "types/generated";
import { StackContext } from "views/Stack/Context";
import useTypedContext from "hooks/useTypedContext";

import useStackRunsBulkActions from "./useStackRunsBulkActions";

const useHasAvailableRunsBulkActions = () => {
  const { hasAtLeastWriteAccess } = useTypedContext(StackContext);
  const allActions = useStackRunsBulkActions();

  return useCallback(
    (runs?: Run[]) => {
      return (
        hasAtLeastWriteAccess.result ||
        allActions.some((action) => runs?.some((run) => action.condition(run)?.result))
      );
    },
    [hasAtLeastWriteAccess.result, allActions]
  );
};

export default useHasAvailableRunsBulkActions;
